import { Box } from "@mui/material";
import PhantomIcon from "@/assets/icons/phantom.svg?react";
import SnifferIcon from "@/assets/icons/sniffer-loader.svg?react";
import PMOLoading from "@/assets/icons/PMO_Loading.svg?react";

const PhantomLoader = ({ global }: { global?: boolean }) => {
  const baseUrl = window?.location?.origin;
  const pathname = window?.location?.pathname;
  const isPublicBugPage = pathname.includes("public/bug");
  const isSniffer = baseUrl?.includes("sniffer") || isPublicBugPage || false;
  const isPmoHub = baseUrl?.includes("pmohub") || false;

  return (
    <Box
      width={global ? "100vw" : "100%"}
      height={global ? "100vh" : "100%"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      minWidth={400}
      minHeight={400}
    >
      {isSniffer ? (
        <SnifferIcon className={"phantom-animation"} width={100} height={100} />
      ) : isPmoHub ? (
        <PMOLoading className={"phantom-animation"} width={100} height={100} />
      ) : (
        <PhantomIcon
          width={100}
          height={100}
          className="phantom-animation"
          viewBox="0 0 32 32"
        />
      )}
    </Box>
  );
};

export default PhantomLoader;
